import {
  GET_CANCEL_SERVICE_ELIGIBILITY_FAILED,
  GET_CANCEL_SERVICE_ELIGIBILITY_PENDING,
  GET_CANCEL_SERVICE_ELIGIBILITY_FULFILLED,
  SET_IS_MOVING_FLOW,
  SET_IS_CHECK_AVAILABILITY_BUTTON_CLICKED,
  SET_IS_MOVING_LOGGED_IN_FLOW,
  SET_MOVING_END_DATE,
  RESET_CANCEL_SERVICE_ELIGIBILITY,
  RESET_SUBMIT_CANCEL_DETAILS,
  GET_CANCEL_SERVICE_PRICING_FAILED,
  GET_CANCEL_SERVICE_PRICING_PENDING,
  SET_CS_SELECTED_CUSTOMER_ID,
  SET_IS_MOVING_STATE,
  SET_CANCEL_MOVING_BUTTON_CLICKED,
  SET_RESI_SAVE_CANCEL,
  SET_CANCEL_SELECTED_REASON,
  SET_RESI_LOGOUT_STATE,
  GET_CANCEL_SERVICE_PRICING_FULFILLED,
  SUBMIT_CANCEL_SERVICE_FAILED,
  SUBMIT_CANCEL_SERVICE_FULFILLED,
  SUBMIT_LOYALITY_CANCEL_SERVICE_FULFILLED,
  SUBMIT_LOYALITY_CANCEL_SERVICE_FAILED,
  SUBMIT_LOYALITY_CANCEL_SERVICE_PENDING,
  SUBMIT_CANCEL_SERVICE_PENDING,
  SET_SAME_ADDRESS_MOVING,
} from "constants-lib/actionTypes"
import { API_STATUSES } from "constants-lib/common"

const initialState = {
  getEligibilityStatus: ``,
  cancelServiceEligibility: {},
  isMovingFlow: false,
  isMovingLoggedInFlow: false,
  movingEndDate: ``,
  previousSelectedCustomerId: ``,
  isFromMovingFlow: false,
  isCancelMovingButtonClicked: false,
  isResiSaveCancel: false,
  selectedReason: ``,
  getCancelServicePricingStatus: ``,
  cancelServicePricing: {},
  cancelServiceSubmitStatus: ``,
  loyalityCancelServiceSubmitStatus: ``,
  loyalityCancelServiceSubmitDetails: {},
  cancelServiceSubmitDetails: {},
  isSameAddressMoving: false,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_CANCEL_SERVICE_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        getEligibilityStatus: API_STATUSES.FULFILLED,
        cancelServiceEligibility: action.payload,
      }

    case GET_CANCEL_SERVICE_ELIGIBILITY_PENDING:
      return {
        ...state,
        getEligibilityStatus: API_STATUSES.PENDING,
        cancelServiceEligibility: {},
        getCancelServicePricingStatus: ``,
        cancelServicePricing: {},
        cancelServiceSubmitStatus: ``,
        cancelServiceSubmitDetails: {},
      }

    case GET_CANCEL_SERVICE_ELIGIBILITY_FAILED:
      return {
        ...state,
        getEligibilityStatus: API_STATUSES.FAILED,
        cancelServiceEligibility: action.payload,
      }

    case GET_CANCEL_SERVICE_PRICING_PENDING:
      return {
        ...state,
        cancelServicePricing: {},
        getCancelServicePricingStatus: API_STATUSES.PENDING,
      }

    case GET_CANCEL_SERVICE_PRICING_FULFILLED:
      return {
        ...state,
        getCancelServicePricingStatus: API_STATUSES.FULFILLED,
        cancelServicePricing: action.payload,
      }

    case GET_CANCEL_SERVICE_PRICING_FAILED:
      return {
        ...state,
        getCancelServicePricingStatus: API_STATUSES.FAILED,
      }

    case SUBMIT_CANCEL_SERVICE_PENDING:
      return {
        ...state,
        cancelServiceSubmitStatus: API_STATUSES.PENDING,
        cancelServiceSubmitDetails: {},
      }

    case SUBMIT_CANCEL_SERVICE_FULFILLED:
      return {
        ...state,
        cancelServiceSubmitStatus: API_STATUSES.FULFILLED,
        cancelServiceSubmitDetails: action.payload,
      }

    case SUBMIT_CANCEL_SERVICE_FAILED:
      return {
        ...state,
        cancelServiceSubmitStatus: API_STATUSES.FAILED,
        cancelServiceSubmitDetails: {},
      }

    case SUBMIT_LOYALITY_CANCEL_SERVICE_PENDING:
      return {
        ...state,
        loyalityCancelServiceSubmitStatus: API_STATUSES.PENDING,
        loyalityCancelServiceSubmitDetails: {},
      }

    case SUBMIT_LOYALITY_CANCEL_SERVICE_FULFILLED:
      return {
        ...state,
        loyalityCancelServiceSubmitStatus: API_STATUSES.FULFILLED,
        loyalityCancelServiceSubmitDetails: action.payload,
      }

    case SUBMIT_LOYALITY_CANCEL_SERVICE_FAILED:
      return {
        ...state,
        loyalityCancelServiceSubmitStatus: API_STATUSES.FAILED,
        loyalityCancelServiceSubmitDetails: {},
      }

    case SET_CS_SELECTED_CUSTOMER_ID:
      return {
        ...state,
        previousSelectedCustomerId: action.payload,
      }

    case SET_IS_MOVING_STATE:
      return {
        ...state,
        isFromMovingFlow: action.payload,
      }

    case SET_CANCEL_MOVING_BUTTON_CLICKED:
      return {
        ...state,
        isCancelMovingButtonClicked: action.payload,
      }

    case SET_RESI_SAVE_CANCEL:
      return {
        ...state,
        isResiSaveCancel: action.payload,
      }

    case SET_CANCEL_SELECTED_REASON:
      return {
        ...state,
        selectedReason: action.payload,
      }

    case SET_RESI_LOGOUT_STATE:
      return {
        ...state,
        previousSelectedCustomerId: ``,
        cancelServiceEligibility: {},
        getEligibilityStatus: ``,
        isResiSaveCancel: false,
      }

    case SET_IS_MOVING_FLOW:
      return {
        ...state,
        isMovingFlow: action.payload,
      }

    case SET_IS_MOVING_LOGGED_IN_FLOW:
      return {
        ...state,
        isMovingLoggedInFlow: action.payload,
      }

    case SET_IS_CHECK_AVAILABILITY_BUTTON_CLICKED:
      return {
        ...state,
        isCheckAvailabilityButtonClicked: action.payload,
      }

    case SET_SAME_ADDRESS_MOVING:
      return {
        ...state,
        isSameAddressMoving: action.payload,
      }

    case SET_MOVING_END_DATE:
      return {
        ...state,
        movingEndDate: action.payload,
      }

    case RESET_SUBMIT_CANCEL_DETAILS:
      return {
        ...state,
        cancelServiceSubmitStatus: ``,
        isMovingLoggedInFlow: false,
        isFromMovingFlow: false,
        loyalityCancelServiceSubmitStatus: ``,
        loyalityCancelServiceSubmitDetails: {},
        cancelServiceSubmitDetails: {},
      }

    case RESET_CANCEL_SERVICE_ELIGIBILITY:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
